import {makeStyles} from '@mui/styles';
import {AlertTypes} from "../../../../utils/alert.utils";

const useStyles = makeStyles((theme:any) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },


    [AlertTypes.SUCCESS]: {
        backgroundColor: theme.palette.success.main,
    },
    [String(AlertTypes.FAILURE)]: {
        backgroundColor: theme.palette.error.main,
    },

    text: {
        color: "white",
        padding: theme.spacing(1)
    },

}));


export default useStyles;
